<template>
  <v-row column wrap v-if="siteKey">
    <v-col d-flex cols="12">
      <yandex-map
        v-show="coords && coords.length > 0"
        style="height: 300px"
        :coords="coords"
        zoom="17"
      >
        <ymap-marker marker-type="placemark" marker-id="1" :coords="coords"></ymap-marker>
      </yandex-map>
    </v-col>
    <v-col cols="12">
      <v-form>
        <v-row column wrap>
          <v-col cols="12">
            <v-text-field v-model="coords" label="Координаты Окрыт"></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="siteData.address" label="Адрес"></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="siteData.work_time" label="Время работы"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="siteData.reception_time" label="Время приема"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="siteData.email" type="email" label="Email"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="siteData.phone_number" label="Телефон"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Site',
  data() {
    return { siteData: {} }
  },
  computed: {
    coords: {
      get() {
        return this.siteData.hasOwnProperty('longitude')
          ? [this.siteData.latitude, this.siteData.longitude]
          : []
      },
      set(el) {
        this.siteData.latitude = el.split(',')[0]
        this.siteData.longitude = el.split(',')[1]
      },
    },
  },
  watch: {
    siteKey(e) {
      this.axios({
        url: `/v1/info/${e}`,
        method: 'get',
      })
        .then((resp) => {
          this.siteData = resp.data
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
  },
  mounted() {},
  methods: {
    mapC(e) {
      this.$log.error(e)
    },
  },
}
</script>
